'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState, useTransition } from 'react';
import { useRouter } from 'next/navigation';
import { useLocalizedPathname, useSearch } from '@personly/libs-hooks';
import type { Locales } from '@personly/libs-types';
import { toPathname } from '@personly/libs-pathnames';
import type { PersonalPlace } from '@/statics/personals';
import Select from '@/components/select';
import usePersonalPlaces from '@/hooks/personalPlaces';
const toPersonalPlaceString = (personalPlace: PersonalPlace): string => [personalPlace.name].join(', ');
interface Props {
  locales: Locales;
  placeholder: string;
  role?: string;
}
const PersonalPlaceSelect = t0 => {
  const $ = _c(21);
  const {
    locales,
    placeholder,
    role: t1
  } = t0;
  const role = t1 === undefined ? "card" : t1;
  const localizedPathname = useLocalizedPathname(locales);
  const [search, setSearch] = useState("");
  const router = useRouter();
  const [personalPlace, setPersonalPlace] = useState(null);
  let t2;
  if ($[0] !== locales.locale) {
    t2 = locales.locale.toUpperCase();
    $[0] = locales.locale;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const languageHandle = t2;
  const [isPending, startTransition] = useTransition();
  const {
    personalPlaces,
    searchPersonalPlaces,
    clearPersonalPlaces
  } = usePersonalPlaces();
  let t3;
  let t4;
  if ($[2] !== clearPersonalPlaces || $[3] !== languageHandle || $[4] !== personalPlaces.length || $[5] !== search || $[6] !== searchPersonalPlaces) {
    t3 = () => {
      if (search) {
        searchPersonalPlaces(search, languageHandle);
      } else {
        if (personalPlaces.length > 0) {
          clearPersonalPlaces();
        }
      }
    };
    t4 = [search, searchPersonalPlaces, clearPersonalPlaces, languageHandle, personalPlaces.length];
    $[2] = clearPersonalPlaces;
    $[3] = languageHandle;
    $[4] = personalPlaces.length;
    $[5] = search;
    $[6] = searchPersonalPlaces;
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== localizedPathname || $[10] !== router) {
    t5 = personalPlace_0 => {
      if (personalPlace_0) {
        const count = personalPlace_0.matchCount + personalPlace_0.personalCount;
        if (count > 0) {
          router.push(localizedPathname(toPathname(personalPlace_0.slug)));
          setPersonalPlace(personalPlace_0);
        }
      }
    };
    $[9] = localizedPathname;
    $[10] = router;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const updateRoute = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = s => startTransition(() => setSearch(s));
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const searchUpdated = t6;
  const {
    options: personalPlaceOptions,
    selectedOption: selectedPersonalPlaceOption
  } = useSearch(personalPlaces, null, personalPlace ?? null, toPersonalPlaceString, _temp);
  let t7;
  if ($[13] !== isPending || $[14] !== personalPlaceOptions || $[15] !== placeholder || $[16] !== role || $[17] !== search || $[18] !== selectedPersonalPlaceOption || $[19] !== updateRoute) {
    t7 = <Select border={true} id="personalPlace" inputId="personalPlaceInput" isSearchable={true} isClearable={true} options={personalPlaceOptions} optionSelected={updateRoute} placeholder={placeholder} role={role} search={search} searchUpdated={searchUpdated} selectedOption={selectedPersonalPlaceOption} disabled={isPending} />;
    $[13] = isPending;
    $[14] = personalPlaceOptions;
    $[15] = placeholder;
    $[16] = role;
    $[17] = search;
    $[18] = selectedPersonalPlaceOption;
    $[19] = updateRoute;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default PersonalPlaceSelect;
function _temp(personalPlace_1) {
  return personalPlace_1;
}